import { FC } from 'react'

type IProps = {
  classes?: string
  width?: string
  height?: string
}

const Logo: FC<IProps> = ({ classes, width, height }) => {
  return (
    <svg
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      width={classes ? '100%' : width}
      height={classes ? 'auto' : height}
      className={classes}
      viewBox='0 0 159 128'
      enableBackground='new 0 0 159 128'
      xmlSpace='preserve'
    >
      <image
        id='image0'
        width='159'
        height='128'
        x='0'
        y='0'
        href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJ8AAACACAYAAAAVm7uuAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAA
CXBIWXMAAAsTAAALEwEAmpwYAAA30klEQVR42u2de1zT1f/H38gYg8GAfWBcNmQDJiI4LFGQFEsx
vOYsv5hGUSiJKaGZF7JIMTW1UjMLQ02EtEhthjcSNaxQEFMua8JgG8IAPzA2NjZ2Q35/sBkSwjYu
w34+Hw8eXD6f9/tzPmcvzudzznmf97GApzzRqNXqER11dW7SS5dmKu7cCQUADJZMFtgGBd3Eh4Vd
wzg5yc1dxqf8B2ktLAy+Fxt7uASg43Ff6P79q1QCgYe5y/qU/whasRjbmJa2lE2h3O9NePov3oIF
Z1oLCyeYu9xPecJRq9UW9du3f2CI6Lp+lU+aVNxy7twcc5f/KU8w9du3rzdWePqvuwEBvOHUAlqY
uwBPMZzWwsIxvIkT2f3xgQ0IKB7NZo8z970AAIwwdwGeYjh2Eyf+7XXmTKTVxInFptg7xsYeoZ07
N9fc96Hnacs3DNGKxZj2lhZH0DUOlg4OYoyTk0Z/XFFS4t20d2+S5MiRZYb4s6RQJC4bNmwgRkdn
YJyc2rpcB6e7jgUAPLB0cJBgnJxUQ3WfT8U3TFCUlIzS8Pm+qnv3fNru3g1or6vzAgCLDisrNdbb
m4Pz8eHaBAX9ZTdx4l8AACqBgNCwe3dKy4EDib35taRQmkgff7zWJS7uGACAViweIc/Pf0HF441u
u3s3qL2uzlt3nTb9dbAeHjW4gIDb1lRqw2De81PxmZmWc+dmSn//PUKRlzdbdf26f2/nWk2cWO7I
ZGY4zJ17ypbBuKsViy2rly/PkGdlLX6cjXta2hsucXEZumu92HLq1KvS7OxFDxobbR9nY0mhNOPC
wvLtp0zJcZg372drKlVo7np6ygCiFYutqleuPFTm4mJ0r7V80qQ7LefOzdD5wZS5uGh6Oq9m48at
unMs67dvf49NoYhM6CHXNqalLTd3fT1lgFGUlPhVr1z5jYlDJw9azp17HgCgtbAwoAfRVAB0vtdV
r1z5hYlDM9WNaWlxWrGYYO66esogoRIIXKpXrtxvigBbCwv9AQDqt29fo/97mYuLRCUQuAIA1Gzc
uNkE0QnQ/fvj1Wq1lbnr5ilDgFYstkL3749nUyiNRgrlrlYsttKKxVblkyYV6OZz3wYAaDl3bpqx
wuMtWPBLa2HheHPXx1PMQMuZM7OMFUz99u3rdbYzeAsWnFEJBC5asdj6bkBApZHCO6MoKQkwdx08
xYw0pqW9YYxo2BRKg1YstgYAUJSUUHQ+YoxsQStVAgF5KO/z6QzHMMQlLu6Yi641M4T22lrX5szM
WAAAWwajFgBAdv58lDHXpHz33f+GekjlqfiGKS4rVnzlGBt71NDzZb//Hqn/ueXcuQh1RcU4Q229
zpyZbTdx4u2hvsen4humYJyc2pxXr95pNXHi34acrxYIRilKSkYBAKh4PLqazTYogNRp48Zt+PDw
y+a4x6fiG8bYMhh3nePidhty7oO6Ol8Nn08HAFAJhSMNsbGeNImNLFnyPcbJSW2O+3sqvmGO08KF
WYY8fttra63UKOqmFYstO1C0z1ZvhIuLlhgbu9eWweCY696eim+Yg3FyUji88soPlhRKa1/ndiiV
Nu0tLU6a1tY+ZyRsJ0++5LRw4U/mvLen4nsCcJgzJ4cQHf21AadaAICFhUaD7etEUlLShxgnpxZz
3tdT8T0heH766Qa7BQsuGHBqR18neJ05M08fmmVOnorvCWLkkSOv4qOifunlFAtLBwd5h5XVg54O
WlIoLW7797/rMH/+WXPfCwAAxtwFeIrhYJycpFqx+LXGceMSJSxWjKawkN71uPXIkZUP8HglxsXl
fndbfFTUeefXXvvWYf78M+a+Dz1Pg0mfUBQlJX4aPt9bde8e3QKHU2E9PKpxAQHF1lRqvaKkZIyG
z/dR3bvnY4HDtXWJTK43d7mf8pRhwdOW7/8Zco3EVtUut1W3K21b1RKk6zE7rKMIa4lrs7bEK/BW
joOe4+Wp+P6DaLXaEVLtfReepDSoSnozlCspnCqQ8sbJtGyiSgsg0/btwx4DYI2BDl+HsBtBxAUn
I7yWZBBx5Eb9cblGYg0AlgBgKVOLnFrVEmeJqtFD3dHqIFU3uUqVMiIAYDoslE4dHRoHCwurEZ72
/jeDnCO+xVs5tgA8Fd9/hmal0AVV3PMtafwjvOB+9qJaxbVnmpSdx+yN6FZaYwAotuF/jnKc9KeX
A01AtQ+6TbIdeRcALJvbGqgSVaMrr6U0sEZ+O4TTXPycTMt2fZyg7TEAztbjlHSH8SVBrhPyxznP
OOqG93m45vip+J5g5BqJdX1rVQC76eZz1+qPL6uSXmPItMaJTX++DyH8zxDXeae8HcaWUOzpJVhL
nLy5rcFHomok30Kvzron/z2ysiXfrzdBd/F1d5TjpKtjXSZcJ+FoVb5O4/N7uvYTIT6pVDpCJpPZ
S6VSR7lcbqdWq631x7BYrNrKykqNxWLVBAKhhUwmi81d3qHgbvP1ScVNuXMvVZ96p0l1x9FYe5kW
wBkHMB6JOTKZMu+0N+GZInss0lQj4wSVi4qfuyu+GcaV3nihScl27UvQel/TPDbs1wmO527nU4K3
cmzrrQzDTnwikcimvLzcv6qqil5bW+tZV1dHFovFTq2trQSZTEbQarVWSqXSpqsNDodrw+FwbTY2
NnI7OzsZgiAiNze3BgqFUuPv788eM2YMx9bW1oA3neFPg7yKdqbq21U37+dEN6nukIy11wtphmfc
gciR8d/4Oo1nyzUSy+Km3Pm/11xYwJXeiGhSst0M9RXqGlYw0fmN70I8ZlywxyIo3spRaWhZhoX4
+Hy+a25u7sy8vLxpd+7cmdDa2uokEAgMqoDewOPx4OLiInJ1dRXQ6fS/IyMjz0dGRuaQSKQnsnXM
rz/5yhH2x3ualGxPU+xlWoAXPOadWRawN9EN71Ot1WotCxtZ805xv9xQJb0WaqgPewxAMGne+YW+
H6T4EiYUYTCYdlPKYzbx8fl895MnTy5KT09fVlZW9siiFTweDzQardzOzk7R0dFhVVZWFiiXy7se
V8rlchwAAIlEEqEo+nDIAEEQma+vb6WFhUWHSCRy4XK5//qgQkNDC5YuXZo6e/bss2QyuclcdWAo
co3E/ujf63ae5qetMOZ9ritTPJb8NIea8Nlo4qRCAID8+pML9hUvPN2kNPwd0RkX0PSMS9jPuhaz
35HPQyo+FEXtysrKGCdOnHg9LS0tvuuxkJCQ63Q6nevt7c0LDAws9fb2rpJIJM4ZGRnL0tPTXwUA
oNPp3MWLF2colUrc0aNH30ZR1Dk1NXUpm80OzM7OflkgEHgBACQkJHy1ePHiTAB4UFVV5cvlcuk8
Hs+npKTk2ZKSksCu101MTPx80aJFx/38/NgIggxZkhxDqRTfevYH7uatRWj2bFPsfQjhJeHuS1Ij
qK8exVs5tjXIq0Z+X/7RrvP3ji8yVHTWGIBniUu/n++77MBo4qTrA3VvQyI+oVCI/Pnnn1N++eUX
ZmZmZoz+74GBgezp06fnBAcHF/r4+FT5+fndRRCkVaFQYE6dOrXwq6++eq+goGACAEBcXNw3ixYt
OhEREfE7i8WKfPvtt79HURTh8/lkV1fX+l9//XXm0aNHl7JYrFcAAKZOnfrHmjVrPp09e/Z5LBbb
gaIovqysbFxFRYXfrVu3Jly6dGmuQCCg6MuSkJCwZ/78+acZDMZfJBJJMRT10hdFDRdnnajY/kmV
9NqzxtrKtAAveiw98Qr9nc98ncb/JddIMLmCH+Kzq/dv4rey3QwRnkwLQLMLEMYGbHk3yDniIt7K
cUDrZdDFl5GR8WpOTs6szMzMN/R/CwkJub5s2bKDEydOLKBQKDUIgjx8pnI4HO+vv/763f379ycC
AJBIpPuff/55QmRk5Dm9KLKysuavWrXqCIqiRA6H4+3v788H6Hx3/OWXXxYkJiZ+AwCAIIh65cqV
25YvX/4lmUyW6K8hFAqJ1dXVtJs3b048fPhwfElJCUN3LemiRYuOzJ8//3RERMTvg103vVHUcHFW
aunGb5pUd7xMsV88auvWGSNjvyLiyGizUkj6qeLLjRfu7VxjjI8w15gfX/KJ3zeQrd2QUFxc7B8X
F5eKx+O10Blj1hEaGvpnVlYWUygUEnuyyc/PDw4NDS3Qn89kMk8VFxfTu5+XlZU1n0QiNQFAB4fD
oXU/XlRUFEilUnld/Jzu6TwAAKFQ6JiRkbGIRCKh+vPpdDovISFhD5/PdzdH3RU1XJy9LDegjnkW
Ooz9WnQROs5wU9+VayQ4AIAGeZXPJ4XzrhrrZ2fh0swGeZVBa0GGDQqFwnLfvn0rqVRqLfzzYd7N
yMh4VSqV2jzOjsVizaZSqTV6m+Tk5I9EIhG+p3P7Eh8AgEgksouLi/tG749EIomKiooCH3d9qVRq
s2/fvncQBBF1sWnOyMh4dSjrr1J8a/yii8aLrqvw9L4a5FW+pvjaWbg0U66RPFnJgTgcDm3u3Lm/
gO7Do1Kp1bt3735PKpXie7NLTU1dqrcJDAwszcrKYvZ2vk58jdCL+PSkpaXF6M8FgA4WizWzt/OF
QqFzcnJyMpVKvae3iYmJOczn840eUzOWBnmV97JL4ypNFV5+/clFel+V4lsTTRTe90+c8HQtV9cP
7Eh+fn6vmc8VCsWI1NTUpXg8Xg0AHSEhITfy8/P7TFJjjPh0ZZvFYDBKAKADQRBxVlbW/L5scnNz
w5lM5in9/UydOvW3K1euhA1W/TUrha67bsZ8b4rwmGehI6t89ya9r0rxrQnLLo0TGutj7bXwvxrk
VX3W50DR7zB6qVSKSU1NjWUymecEAoEnnU6v3Ldv38rdu3cnhoWF3ezN9tixY2+tXbv2a7lcbhUZ
GZlz4MCBuLCwsFsGXtrgzhKTybywd+/e+MDAwDKRSOS4adOmz7Kysl7qzSYiIuLagQMHliUnJyfj
8XhVXl7e1OXLl6cPxmNYrpFgc6uPv5l/P32JsbYyLcAk0tITc7zj9gMANCuFHqcrv9zQpLpj9K5D
cYE733HD+/AH+v4GBRRF7ZKTkz+Cf1qHq7m5ueGG2KampsZClw5BcXHxaEOva8g7X08UFRWNQRCk
CXSP99zc3Ml92SgUCousrCymvuUEgI7du3cb1Wvss1wNF2eb+p63LDdA2KwUegAAyDUSwo8VW7cY
62M6CzqyyndvHMh7MgSTWz4URe23bdu2JSUlJQUAYPr06blHjx5dHBERca0vWxaLNTs+Pv6wzu7y
hx9++HFQUNBdE4ticAsYHBz8d3Z2dgQej28tKysLXLFixZGioqJeU4LZ2tp2REVFsVJTU9+aOnVq
HgDAunXrvkhOTk5Wq9X9fnI0K4XuqWVrD6pMnHl+/9lDC4k4ch0AAEd0Y8pp3kfJxvoYRwy/E+G1
JL2/92IsJlUeiqL2mzZt2rVv3773AAAiIyMv5uTkzKTRaH1mL8/Pzx+/evXqgwAAoaGhN3bu3Ple
cHBwqZFFsAATxyjDwsLuZGdnv4ggSBOXy6VHRkbmdZ2e68Xu1tGjR1+dO3duNgBASkrKlg8//HCb
QqHo1yKsE+WbN/Nb2RRj7WRagCX03R/4EibcAOh83KaWrT1siogXj/rgQyKOPOTrO4wWH4qihE2b
Nu3ST48lJCTsPXfu3GxDJpf5fL57UlLSFwKBgEKn0yu3b9++Pjg4uGSob3ratGnXDx8+/AaJREJF
IhEyb968C2q12rIvOxqN1pCenr4kOjo6HQBg165dGz/99NMPpFKpSeljixouzjnNT3vblPnaccTw
O+GUl7MwGEwHAMBPFV+u47eyXY31M2vkhgP+SOjVga5jQzBafNu2bftYL7z169dv37Zt2wZ9BfSG
SCTC79279/28vLxwnZ8N06ZNM9ssApPJvLBp06bNeDy+raCgYMInn3zyoSF2CIK07tu37x29AFNS
UrZ89913bxt7fblGQkgtW/utKcKzxgC8Qn93pxvepwqgcyD5wr2dq431ZY0BGE96YcCnzQzFKPGl
pqYu1T9qExMTv3j//fd3EAgEgzIcnT9/fu6hQ4feAQBITk7+OCoq6nQ/y97vqcHo6OjvlizpfNdJ
TU19l8ViGTR5jyCIYuvWrUnR0dEZurr4ythe8Fn+/vVNSsPSmHVnPBLz82inSQ/frU9VfvqxIesy
evBzyttxbFF/69FUDBYfi8WavXbt2i8BAOLi4lKTk5M3k0ikPpPXAHROte3cufNjuVyOmzt3bvaq
Vav2meuGu4IgiPKDDz7YTKfTuSiKEr/55pt3De0902i0+k2bNm2Ojo7OBABYvXr1QUPGKAEA7jZf
n3zp3g/rTC23n+OkP/SdjAZ5lc+1+rTXTWlBqYTAO0QceVB3GeoNg8RXVFQ09tNPP/1YLpfbAgC0
tbXZ3L59e9zj5mi7s3v37o1lZWX+AACbN2/+kEQi9TdBTQf8k5Okz0d+b9BotPvffPPNUgCAnJyc
SH1UTF/w+XxKaWnpuNbWVnsAAJFIRFizZk2qVCq1681OrpFg82pZMU1Kdp/JfHrChxDOnuI570f9
73nC42+a0slwxgVIvB3G3ulP3fWXPsWHoijh4MGDK2/cuDFR/7fMzMyYiIiIa2QyWRQYGMiOi4v7
Jisri8nhcLwUCsUjL+4ZGRn/00e0ZGRkvGqODkZfRERE/J6YmPgFAEBSUtLu7jMZUqkUV1xcPCot
LS0mJibmOyqVWkej0WqioqJOsVish7MlBQUFwWvXrt3b27U4ohuzrtTtNGjDvp6Y4bUklYgjCwEA
5BqJQ2HDpQWm+KESvEv8kVCzRu702VifPn36f2m67Y8SEhL2KpVKXEVFxei6ujoql8ullpWVjSkr
KxvTNTh0+vTpv44fP74oODj4RlRU1I8AAEwm8xSDwRjIvL/9avG6s3r16p0nTpyIQVEU+eKLLzak
pqae4fF4Pnl5eREEAmFiTzZ0Or3a29u7fNSoUZyampqRLBZrwfHjx5dmZGRcff3117/vfn6zUuhy
qPSDOGOih7vijAuon+LxagZAZ1UXN+XOalGLTAq5csGNKdavnzUXvVZBUVHR2MWLF28CAIiOjs74
/PPP12GxWC2fz3etqqqiV1ZWjqqrq/Pg8Xi+JSUl40pKSoIAAC5fvvzi5cuXX+zqq7KycvQXX3yx
MTk5WeDh4SF0c3OrJxAILQQCQaJbfabC4XBt+u8IgmgeVy4sFmvQIhWpVGqh0WgwSqXSRq1WY5VK
pY1cLrdXq9XWSqXSpqmpidTc3IzU1dWRP/roI7qtra0GAODs2bMvnT179pHpNzwe3xYYGFhMp9PL
vb29qzw9PWt8fHwq/fz87pLJ5CYURQn19fWUgoKCCZmZmW9zOJwCf3//yq4+eJLS5/Lvp88xRXgy
LcAs0twfugqmRsYJbFKy7Yz3BuDlQCs3xW4g6bUaDh48uJLL5dKoVCp/9erVn2GxWC1A53sSANwH
gD8AOoM46+vrySiKujY2NrrW1NR45uXlvZCXl/eC3ldZWVlA97UaAAAIgjS7u7vXubq61tvb28tc
XFxQW1tbeXJycouNjU0bBoPRYrFYlbW1tcrS0rIdh8O1Xb58OVQul+MBAFgs1ssZGRm1SqUS197e
bqlSqazVarW1VqvFfPbZZ7YtLS0OCoXCtrGx0UUsFhPr6uoodXV1nvo1IL3BZDJPMxiMO3Q6vdzd
3b3O0dFR7O7uLuwamKqHRCJJc3Nz10ZERFzLyckJZ7FYUQqFYpd+1ZxcI7Hdc/t1k6ew7DEA833e
/mo57ASAzkHlQ6UfjDHVn7M11exzuI8VX25ubnhERMRyAIA1a9Z81tu7WhcxAkDnfGhLS4tDXl7e
C1Qq9d7GjRu3WFpatnO53FEVFRWjKisr6WVlZQwAAJFI5CQSiZzKysoeG2vXG0lJSZ8ZafJIR4XB
YBR7e3tXMRiMYjqdXl5bW+u5Z8+eDSiKuoSEhFxfu3bt51gs1qBHfERExO9xcXFpaWlpcUeOHFk2
e/bs8wBwBwAgV/DDiiI0O8TUDyqYNO9XN7wPT/87T1L6bEVL0TRT/VHs6aZOZw4YjxXfihUrvgMA
iIyMzHnxxRcvGuO0urqaWlZWFgQAMHny5N/i4+OP6I9JpVJLjUZj1d7ejhGJRESxWIygKOrW0NDg
XldXR6mvr/dobGwkNTQ0uIlEIqS5uZkoEomcdeZdRfDYcT4EQZrc3d0bEARpdnJyErm4uKDu7u51
Hh4etW5ubvUUCuUegiCNeDxeYWlpqUYQRM1isQAAAEVRWx6P55OWlrbi+++/X2qsuN97771P09LS
lvn5+VUQCIQWgM4B5djLjsb+kzxEpgWY5hlzCCD74d/UHa12TUq2g6k+7bGI2Vft9Si+rKysBVFR
Ud4AANHR0Uf9/f15xjj99ddfZ16+fDkCADo2bdr0cWZm5sNjBAKhHQD0U3GtAHDPUL9ardYSg8G0
Z2RkRK1du/YAiqLOxcXFjICAgL8BAPRTfCKRCEQikUkVQiKRFFlZWTmnT59+taysbHRGRsbi119/
/YSh9v7+/rzU1NR3iERiK41G4wMAZPO++NDUTgYAAM0uoCHIOeJX/e9yjcQ+k7Mj1NjUGHqccQGN
eCtHqWmlGTh6HGo5cODAuwCd7zzTpk27ZIxDPp/vcfXq1QiAzkgXf39/wUAVVi8ua2trFehaPiwW
24rBYNpNXbjcE9OnT784ZcqUqwAAp06d+p+x9rGxsd/OnTv3JEDnIPDP/JR1pgpPpgV40fPNrwHg
4WieTC0iNSr/ftZUn654B8lA1VV/+Jf4WCzW7LKysrEAAHPmzPmFTCYb1YQUFxcHsVislwEAkpKS
tg5SuS3gn0fwgOeVRhBE9dxzz10DAGCz2WMNnbnQg8ViH9ja2ioBAM5UfbvO1HApgM4cKM+Spl3s
mi+vVS0hljZnTzHVp1KDeWCq7UDyrw/u8uXLESKRCAkJCbkxf/58o+ZfpVKp5V9//RUMAECn08sn
TpxYOEjl7jrDMSgVuXDhwh90YVe+XXvtxnC3+frkm+jZpf0px7PEpT8RbdweeTWRqBpd+yNoJ5xD
82DUmbE8Ir6ioqLAmzdvhgIAREZGXiCRSDJjnIlEIhcWi/U/AIDY2NjDBAJh2GUAMBQajXZ/0qRJ
+QAAbDabIRQKnY2xl2sk1nm1rOgmJdvkeD9rDMAUz1ksIo78SIJvoUzga0ogwXDjEfHdvn372Rs3
bkwCAFi8eHGGsc74fL53SUnJWACAGTNm5AxiuS0e8/OAsmjRohMAAAUFBVPKy8sNDvMHAOCIbkRe
qdu5vD/XH0ucd92b8MwjTw+5RmJ7V3zToKQ+j8MGY2/WmQ09D8WHoqh9YWFhKAAAg8G4o88CYAwX
L16cA9AZ2ezu7l47yGUf9GwL8+fPZwEAcLlcakVFhZ+hds1KoWte3bHlTQYnC+uZYNc5WW54n0dm
SVTtcgdpO2esqZ2N4cRD8VVWVvpdv359MgDAO++885WxjkQikc3PP/8cBQAQERGRQyaTh8V7RX8g
EAjKyMjIHAAANpsdiKKoQetZf6/Jfu33uuOz+yMQH0I4Z5zzjOweDllUtuSbPLOh9zFYdWYMD8VX
W1tL0fVyOyIjI88Z6whFUVcul+sLAECn0yuG8B4GtSJnz579CwBAYWHhc10Gux9LpfjWhOzq/QZF
RfdGiOu84/pI5a40tzV49KezoWNAgzJMZQRAZ9pZ/fBKaGhogaurK2qso6KiohCAzsxTFAqlxtw3
NlDoh1wKCgom1NfX9xl5fLryy3X8VrZTf67pjAto0K/D7Y5E1ej2X+hsAOjEJ5PJ7PRDJC+++OJF
W1tbo4cvrl279gIAwLhx424hCNJorP1wxd3dXahb6wtCobDXVWb59ScX5wjT/9efx61MCxAbsCXx
ceFOvJbSceauk4FC3/I5Xr16dRYAwLPPPmtSTP9vv/0WAQDg7e1dacgSyicFHA7XNmXKlDwAAC6X
6yeVSnuMQG6QV/nuK154vL/CC3UNKwpzX5j1uHMalRVG9bqHMyMAAOrr6ylyudwKAMDPz8+knae5
XK43AICHh0fdEN/DoL6/IAiiDAkJuQ4A8Ndff4V2T0YOACDXSPCH2KvT+vsu5owDSGBkLOrtnDoF
e9x/oacLoBNfVVUVHQCAwWCwcTic0QMEfD7fBQAAj8driUTiUPVyh+ylWf8OW1ZWFqDptpGyXCOx
Osvfn1SEZj/f3+skBp2M6ho21R2tVmtZ2ZIfYIzP4cwIAICampqRAAAMBuMWFos1elaCz+fTAcDC
w8NDSCQSn8hM773h7u5eDwAdAoGAolarHwlCLW7KfeVExUebTHT9kMWjtqYEOUec7+0cVUcrfgB6
usOGEQAAPB7PBwDAw8OjFofDtRnrRCgUegJ0xtE5OjpKhqDcQzpU4OjoKAYASEhIOKiP0QMAKGq4
OO8I++Nv+ut/EmnpTzNGxqb2tdlefWuV33+lpwugi+errKykAwC4uLg02tjYGC2+hoYGdwAABwcH
CR6PHxbJtAcSKysrix07dnz0xhtvHEIQRAoAcLf5+nOf/bXsaJOS7WiqX5kWYPbIJb+8NSZltSG5
UiSqxoFK0zssxvkwAP+Ix9HRUWxra2t0wRobG0kAADY2NoquLcMgMyDrdg0hKCioFABKk5KSAKBz
IHlTwfg/+vMI1AnvVCLj2KsYDMYgT7yW0mf6ey8yLQDOEm9UwMhgMQIAoLGx0QUAwMHBwaT3tba2
NhwAgJ2dndjKymooIlm6jkMOuPi6rz3uSlHDxbnv/zm+sH8xegHi5f67N6199vhCQ4UHANCoNHx+
uQ+GT8unXwl26dKlmampqT1NIXWfwnpYeEtLS21mZmYQAACXyx114sSJJampqZpuNh2PszewMh65
3qVLl0LkcrkdAMCJEyei09LS7rW3t3cdgLDozUcP92YBnXvHjlCpVE7Hjh3T8Pl8Fo1G4+pPkmsk
trmCH5bvvjPzC1Mr2xrTmWflJZ/4z0cTJ/1prD2vpTxwIIZZMBZDNiLRK/oP6QEMk8lmM9MRHR19
ceHChT9NmTLlDIIgzQCdofBnqr5dd+GeaSFSOtGdnkyZ98Nop0lXiDjjosP1LMsNaGhSGp8GrSsy
LcDbY7buWDTqow8Gvzp755H/IzqdXokgiLijo8MC/nm0dUDPrZgFADywsLBo53K5fiKRyBlBELGv
r2+5hYUF6Hx0x5DmvrdYvQ4LC4t2kUiEcLlcPwAABoNRYmtrK+/o6LDswa7r9xHwaFLJR47R6XT+
woULT0yYMOEamUx+GA6WX3/yrUPs1euL0GyjZhb024COJc675YIbc9vB2lpWK+UH1kr5gQdLNpAc
cXZSiw6cmkKgVZBwtEpfp/G9brTSrBR6xOaS+yU8PQ7WLsNiBuoR8SUnJ2+KjIy8BP8sVulJLI+I
EYfDaRISEg6kp6cvnTVr1pmtW7d+iMfjpfDoOgvoYtNdzN199/q7paVlx+nTp1/etGnTZyiKko4c
OfIajUbjt7e39+Szq8C6ZzO16Oa3HUGQhy/iDfKqMacqPz2w69bC5w2tTP0wCM0uoG4Wae4v2o5m
F15LeZCgJWceWGisH9czdrYep9l1M+Y3BmnSpYmu804QceR/xUKiins+hpajLwhY5/v999J/MAAA
JBIJRVHUVfez0Z2O9evX3wcAaG1tJeDxeKmx4ffGkpWV9bBHjcfjZV23z+ovDfKqwDNV326Lv+rz
kjF2AUgYl4HMOjHeZfZpiarR8+K9A2sNnfVoUt2xarp/Z0b+/fQZ33Hidx0ojst6xXfjpq6BpAJZ
sdH7rz0OojXZ4OWqgwkGAMDNza0BRVHX5uZmo9Yp6HFychIDAGi1WqxcLrcHgMHuynd/nJqMXCMh
qtrlCE9SGplXdywp/qqPR9f1sNYYAJUWwBkXANBhpXawJjS42tDYDtZudV4OtLtU+6ACT3v/W3gr
R4Vccx53lr8/6USF8Um59ai0AKf5aVGXatKifihP/uJ5SszXbnifquoWvu9AVZ6jNUk4UL76AwYA
YOTIkdUlJSVBIpEIkUqllrqF3Qbj5OTUDAAgk8kcpFKp/RDfg8nDBg3yKt/iptzZt9GcGLGqgYq1
IEonkZYWOuKcqx1xdiKLDpzUeoR9k4udcy3Wwk7uaO1yn2jjVqtPUdbd157brx+8Wpc9rb89Ur19
GiflvdyaU6+f4abuuFZ/3KQVdN1xxg2PbAUAOvHpV9bX19d7KJVKawAwapbCzc2tHgBALBa76KJ9
zZ4ByVBIONqdyJHxJXZYRxRriWu1tsRLAOAB3srRoKyrAABFDRdf/vD6S4f0QaTdp8BMFaM9BqBJ
yXb5rjze5OGdf/sMqDdXDubuYAAAfH19uQAAPB5vlEajsQEjxUej0ToTUzc0uEulUpPzhxjBgKxe
071TVZpqDwBwt/n61Ms1R5ZMIM3NmueVwHGxc9aHlI1obG2i1CpuTb5Wn8bsT7qMgcSfGFQIwDZ3
MQBAJz4vLy8+AEBpaWmQWq22NtYJhUKpBQBAUdRBJpM9WZvG9RNPe/9bb47ZHQsAGryV47/mxeUa
ydeL/TYTf6r4MimLt3OlOQUo0wJ44p+5AXDcjDX2D/rHLhcAAEVRRLdOwaiAUARBHraUtbW1nua+
qcFArVZj9PkJu9LX41knSCEArMoq3y05zl3X7/Cr/sBwmZxnzut3ZQQAAIFAkIaEhBQAANy8edOk
HHK6rU6Bx+N5oyg6FJ2OIZmRkUqltrt37/4wKioqJysr67X++AqnvJzujAvo52pe03HGAZBsR5o9
KaSeh+KbOHHidQCAq1evRigUCqOHL6ZOnXoVAKCiomJMfX09eQjvYVBFKBQK3datW7eVxWJNw2Kx
/RpCwlriZKMcgo2e0x0IZFqA8UjMCWtLvNlTo+kZAQCAIEgbg8G4AwDAYrGYra2tRr+36ZcYFhUV
TRCJRH3uZfakUFpaGgQAQKVShRQKRTAALs02hz6ZMu/n4dLTBegyQOvj41OpXyKoz7diDL6+vhUA
0CGXy22qqqoGbEC0F4bkQ7x06dJMAIDJkydf6e+SUHW70l7d0TxQAaFG4YwDIOFoAnNc+3E8FJ+7
u3uDfong0aNH44x1RCKRWplM5mkAgMLCwkmGppYwkSFJFAQAkJaW9jYAQEBAQAmNRuvvzowWAilv
KP4xH0GmBXiWuPTH7qnWzM1D8fn7+1c999xzvwMAZGZmvq5QKGyMdbZkyZIMAIC0tLTlhqSWGO7k
5+c/CwCAx+M7/P39+z04JlGh7k1Ktkk7VPYH+85Ua6e7p1ozN490LJ555plbVCpVAABw6tQpprHO
xo4de0e/hkOfPmMQGfTH7o8//vgaAMDkyZNz/fz8+p29vaTxjwhzLAAKJs37w5vwzM2hv3LvPCI+
BoNxZ/LkznGgH3/88TWtVmvUB4wgiGjJkiXHdPbRarV6sAQy6GHgUqkUe/78+QUAAEFBQbdMSRnX
FblGgi9u/rlfqTRMZZRD+K9ueJ9hM8Si5xHxkUik1gkTJhQAABQWFob89ttvRuX9JZFIreHh4VcB
AM6ePTu7qqrKoB0cTaBrbN6gCPHKlSvTuVwujUQitQQHB/c7vS9HdGM6W5Q/UGswDMaHEM4Jp7z8
ff89DTz/Gs9buHDhj3Q6vRxFUefs7GymsQ79/f05+gHr1NTUhEEq96C3fOfOnZuvu5/S559//nJ/
/Z2o2L5lsMvcExPdZpzsLQuCOfmX+MhkcvOCBQtOAwCcP3/+pStXrhjV+o0ZM6ZMn99v3759q03p
uPSFbu+1DgAAAoFg9DrjvsjPzx9fUFDwPADA1KlTL5NIpH4NzObXn1x8p/nauIEuZ19YY6BjLi3h
86G+rqH0+E4mlUptCASCHAAsEhMT9yQnJ39kTLRwbm7ulBUrVhzlcrneO3bsWJ+UlLS7+zn6WRSt
VmsJAJZKpRIrl8ttRCKRi1QqdZRKpQSZTEZobm4mKhQKvFgsdlKpVLgHDx5Y/P3332Nu3LgRLpfL
cUwm87Snp+e9ESNGdFhbWyudnJzEtra2CiKRKLK3t5fpNhds0e84pMtF095bzGJycvJHKSkpKQAA
QqHQnUw2fUPkZqWQvOI3cu1Qp7mQaQG2hpx8Jcx9YX93dB80enz9JRAIbTt27FiXlJT02aFDh+Jf
eOGFXAA4b6hT3R5kOVwud8WJEyeii4uLf8FisSqxWOyMoqhbdXU1LSkpybe6utq7vr7eg8/n+5o6
Lqjf88NQSCSSyNvbmxcdHV3h4eFRSyaTa7y8vPgUCuUeHo+XlpeXB+zYsYMJAJCYmLi3P8KTaySE
A3cSvzSH8F7wmHdhOAsPoJfhChRFCfPmzfu1oKAghMlksg4cOLCstw1hpFKppUgkItXX13soFAqb
jIyMt9LT02MBAKhUarVMJnMSiUR9CgxBkDYikdhoY2OjcHJyuo/D4dpsbGwUdnZ2rZaWllosFqvi
8Xg+XVs+FxcXtK2tzQ4AoLW11b6trQ3f0tJCVCgU9lKp1KGxsZEkl/fdcJNIJKmtrW2rQCDwAOjc
TZxGo5kUci7XSOzO8vdvOlHxkck7TZqKNQZgW8itYF+n8beG+trG8NiOP4lEkrJYrM1MJvMCi8Vi
6uZu9+iPS6VSDJ/P9+Hz+T7V1dW0jz76yKe6uppWWVk5pqysbFRXXwKB4OGGxFQq9Z6XlxefSqXy
vLy8BAiCNBGJxGZ7e3spgUCQ4nA4JRaLVVlZWWn0GbP0yYuwWKzGyspKdebMmQWlpaXBcrkct379
+u1eXl4CALBQq9VYAADd/rrWunRmHbq9dnG6R7l9c3MzIhQKKXV1deSamhovDoczFkVRJ13rSwAA
SE5O3twP4eHP8dLWneAOvfAAAJb4pCYMd+EB9DFQKxKJbFNSUlL27du3Fo/HK7///vtX1Go1tqio
aGJFRYV/Q0MDmcfjBaAoatuT/dSpU6/qd++JiYk5nJCQsNfd3b0OAACHwymtrKw0BAJBA0aSlZXF
XLVq1SEURREOh+Pr7+9fZYy9QqGw0Gq1GKVSidNoNFi1Wm0lEolcYmNjM0tKShgkEkmSl5cXbKxf
AAC5RuKYydnxqakLzPuDTAvwosfS43GMlDVEHNnovNpDTa9DngiCKIqKio7euHEjvKCgYMLSpUuP
K5VKW30W066EhoYWhIeHXw0LC/vDz8/vrpeXl9DW1lYZFxf3dVpa2ooLFy7MXb58+YHhsEWCLhmS
RvcFAAAsFuuZkpISBgDAtm3b1poivLvN18MT85473aRkmyWqh4Yfd2++77IDT4LwAPoQHwBAcHBw
WVZW1vYVK1Z8JxKJHAEAGAxGaUhISH5gYGDphAkTCgMDA/8mEAjyGzdu/Mt+27ZtSZcuXZopEAho
W7Zs2c7n82MHYIK+695r/R7zEwqFLmQy+TwAQHR09I/67Q8MQa6R2Na3VgXl3Et9d+W1Sa+aM0w+
NvDDtaOJnVt2PQkYVFVRUVGs5OTkwJSUlK0AAEwm82RycvJWDAbT5wdPIpFasrKy1kRFRbFycnJm
/vDDD68BgMkbH3dhQKbu1Gq1RWxs7GcAAHQ6ve7NN988TCaTe11aKNdIsDK1iFIr4zK+ur025q/m
w2ZfILSEvntjmPvCk+YrgfEYXF2rVq36ksfj+WZmZsYcO3bsLd1GLz8YYjtz5szz69ev375r164P
kpKSdrNYrL+ZTKbBQzc90D31hcmkp6e/npmZ+QYAQGxs7Dfh4eFX9Mca5FVeEhVKAQDLVnWLi7qj
ldDY2uSeydlBv4meZTYp2Y76BebmEp5MCxBJjjkxxzvuG4B15imEiRhcZSQSSSoUCtf+8ccfUwQC
gXdKSsoWFoslNUREBAJBw+FwDhcXF0/IycmZsXr16gMcDmdafyfr+8uVK1fCli9f/iEAwNy5c3OW
Ll2aisViHw4+86S3Jx1hf3wAAJxkWraFfryua0YDc69GG0cM/2vZ2O1rh8PO4cZi1FoNMpksOnny
5EsA0MHlcketXr16P4vFmm2Irb+/P2/FihVfUqnUeoFAQE1KStqDomh/durpnm3KKDgcDnXnzp0f
c7lcOgDA7t27E0kk0iOP2yDniAsyLZvIb/1HeADDY/2tTAtAswuoXzf+u/8ZklJ3OGL0QqHg4GB2
fn7+eBKJdF8gEHgzmcyzGRkZrxpiy2Qyz65Zs2Y7AACLxZq/devWzVKp1NS5X5Mfu0Kh0Gnbtm0p
OTk5L+rK8pK/v/+/sizgrRxb1o27uGA4iK07NLuApo3jj80brkEDhmBSkp2wsLDbLBZrji56xeL1
118/kZqauswQ28TExK/Wr1+/EwBg//79737yyScfS6VSnCG2A4FQKCR+8MEHX2RmZr4OALBv3753
mUxm9uPOD3abyfow+CLTGRcwYJmw+osPIZy9cfyxWU/CQHJvmJzhKSws7NaePXtWTp8+/TIAQHx8
fFpycnKyUCjsc4xr165dG6Ojo7/X/bzhwIEDCVKp1NhMCUa3fCiK2m3evHlbenr6mwAAycnJW+Li
4r7tyy7YbeaZjeOPRcwaueFbZ1yA2ZJpy7QAwaR5V1eM3fOmr9N4k7YpG07064ESFhZ2q7i4eNXH
H3+8ncViLUhJSdlSXV1NKyoq2hMcHFzSm+3OnTvXWFpatqenp7+RlJS0q62tzUYqle4iEAiDsqha
96jdlJaWFg8AsH79+k8TExO/sLW1NSiBua/T+BtyjYQ9lcI8Xi4qDimXXA+rkBSHNqnuDEi20L7Q
Za8/+Zrf1g1P8qO2K/1+mwkKCrorFAqXeXp6Vu/fv391enr6m+Xl5YGpqakHY2NjD2Ox2B7HAslk
ciOfz/8AACA9Pf2NlJSULWKxmCiVSjcOtAD5fD5p8+bNm9PS0lYAdEarvP/++zv1e2oYCt7KUQYA
eQCQ16wUuuZWH1/5a43mvSYlGz+Q5e2JKO8Nn/9v1LufEXGmR9kMNwbkVZpMJjdLpdKNAQEBZfHx
8Ydu3LgRXFpaGnzx4sU5HA5nrb+/f4//qTQaTcjn85Pa29tHZGZmRu/fvz9RKpUShELh+r4GesHA
xy6Hw6GtWbPmM33oVVxc3Ldbt27dRCAQTFo8rdVqMYWNrFcPlX7wcoWkeGKTanCFZ40BeMs/NX6K
x6vHdeL/z9CvrJ5dIRAIqvj4+MNFRUWMyMjIS3K5HFgsFtPf378qOTn5I6FQ2ONSShqNVrdv374V
CQkJ+wAA0tPT33r55ZfP5ufnjzfw0o+dZcnNzZ0ya9asq3rhrV+/fldaWtpyU4RXKb4VcrBkw1ev
5WI0u24tzMi/n76gSXVnUNOC+BDCS7ZMvP7cTK/4g/814QEM0vJDkUhkd+TIkbiMjIy3S0pKRgN0
xvRt3LhxS2Rk5Fkajdbjyn9dAOsuAAA8Ht+2d+/eFS+//PKPCII88hjOysqav2rVqmMoihI4HI5P
95ZVJBLZfvvtt+/oI6h1194eHx/fZ+dCj1wjsZWpReQ7TZeYv9cdi2eL8r27Di4PJs64AMmMka/u
nzEyNpWIIw/1FrJDxqCufS0qKhqbkZHx5pkzZxYLBAJ3AIDAwMCyuLi4r59//vlcCoVS011YaWlp
bx06dCihoKDgGQCAhISEPTExMYeDg4MfLtrWiS8DRVH77uIrKioK2Lt377rMzMwYAIDIyMhf161b
t+v555+/0ttctFwjwcjUIopEhXqVi4rDKmXXIgvR41OHcs5Wv0nMNM/F3wW7zczuv8fhzaAvvJZK
pZjCwsJJ2dnZzEOHDiXK5XJLgM49PxYsWPBjcHDwTT8/v3I6nV5ha2v7AAAgPz8/+ODBgyv1QyIM
BqN03bp1n0ybNu1XMpksycrKemnVqlXpKIo6cjgcmr+/v4DP57v+8ssvC9LS0laUlZUxAAASExP3
xcfHf+3v71/RU9nkGolNfWtVEKrkj66V8v0qWq5FljZnP2OObUWDSfOuTfOM+Wa006S8J3XGwliG
LGOSSCTClZeXj2GxWK/s2rUrSX9tPB7fHhwc/CeDwbjt6+vLnTBhQqEuO8CI8+fPz01JSdnN5XLd
AQCio6OPvvnmm4f4fL73tm3bPhEIBJ5FRUVBPB7P+/jx42+yWCym7nIdGRkZr82ePZuFIMgjq9sa
5FUjedLbz9VK+WP4LXefRZXc4FrFNZI5BKfb1p4zh/re1tFOk67+l3qyhmCWdF1CoRA5duzYW3v2
7FmPoqhL12NUKrXRzc2t2tfXt8LDw6NOLBa7nD59OlokElnqjvPt7OxkfD7fWy6X40NDQ69zudxR
utwwHXPnzr1w8ODBGH1vWa6R2NXIOP7FTbmzals5wRzR35OaVHfMlkemy0YxDbEBWxKDnCMu/Bc7
E4Zg9v3WiouLR586dSoqLy9venV19UiBQEA1wOxf725Tp069vmbNms9nzHk+p0bG8bnTeGFmaXPu
PLYof7L+Azf3HK0zLqDlGZew89M9Yw+YsvHffw2zi68rfD7f7Y8//gjncrmj6+vryY2NjW5isRgR
iURIa2srXtXSbgMAFvXiGgQAwIoAWrcgK3nItPHFE+YE3FJhhW7shovzm5RgAwAW5habNQaAYhvO
JeHoxVM8Z50a7TTp95728Pj/yrASX3dQFLUViUQIr549plx4J7jyPnssKqt3q2r8KwQAcFgndYfd
BOhwxoE+5Mks96NvWZ1xAPaYgBY6IfQKzWH0HQqBxiXhaFW+TuP7nevlv8iwE1+zUohpbmtwk6ga
nYQygafqgYwgVjV5NCr/HiWQ8gJkWvY4AMBC5/64luZYkA3Q+QjXtWwlJBz979FOE26Q7amVjtYu
jUQbt5r/Lz3W/jDsItVQxT1HgazYr0pyK1CsavAQSHn+Mi17LHQKzVKmBQUAKKFTgFbQKUIr6PKP
ZOzjtreceXqR+TqE3SBaU2vsMJ71bjY0vh8SVOBoTWoAALDHIvUAAHgrR7Nlmn8SGXYtX3fkGgkO
OgUGqnY5Vt2uxLaqJfYSVaOrbk0FWfVARuiwUNpIlK1EbUczEQDslO1yVwCwb9PKPADAFv4RqwUA
PLDB2N8HgDacJb4OY0G852Bt3TIC7FusR9iLyfbUcjusg8jRmlSHtcQprC3xMuhcZtmBt3I0ep3x
U3rm/wC97lTJEJdBfgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMi0wOS0yN1QxMzo1NTo1MCswMjow
MIAYdkwAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjItMDktMjdUMTM6NTU6NTArMDI6MDDxRc7wAAAA
AElFTkSuQmCC'
      />
    </svg>
  )
}

export default Logo
